// Seasonal touches that switch themselves on and off each year.
//
//   <span data-season-from="10-24" data-season-to="11-01" hidden>…</span>
//
// Dates are MM-DD in the visitor's own time zone, both days included.
// A window may wrap the new year ("12-20" to "01-05"). The element stays
// hidden with JS off. Add ?season=on to the URL to preview any day.
//
// With data-season-old / data-season-new, the element isn't unhidden:
// instead its last word, if it matches data-season-old, gets the new
// word written over it once (CSS: .gg-swap in components/season.css).
// Screen readers still read the original.
//
// With data-season-crawl="4", that many spiders scuttle across the
// screen once per visit (crawl.js).

import crawl from "./crawl.js";

function mmdd(date) {
    return String(date.getMonth() + 1).padStart(2, "0") + "-" + String(date.getDate()).padStart(2, "0");
}

export default function season() {
    const els = document.querySelectorAll("[data-season-from][data-season-to]");
    if (!els.length) return;

    const preview = new URLSearchParams(location.search).get("season") === "on";
    const today = mmdd(new Date());

    els.forEach((el) => {
        const from = el.dataset.seasonFrom;
        const to = el.dataset.seasonTo;
        const inWindow = from <= to
            ? today >= from && today <= to
            : today >= from || today <= to;
        if (!preview && !inWindow) return;
        if (el.dataset.seasonCrawl) crawl(parseInt(el.dataset.seasonCrawl, 10) || 4);
        else if (el.dataset.seasonOld) swap(el, el.dataset.seasonOld, el.dataset.seasonNew);
        else el.hidden = false;
    });
}

function swap(el, oldWord, newWord) {
    if (el.children.length) return;
    const text = el.textContent.trim();
    if (text !== oldWord && !text.endsWith(" " + oldWord)) return;

    const wrap = document.createElement("span");
    wrap.className = "gg-swap";
    const before = document.createElement("span");
    before.className = "gg-swap__old";
    before.textContent = oldWord;
    const after = document.createElement("span");
    after.className = "gg-swap__new";
    after.setAttribute("aria-hidden", "true");
    after.textContent = newWord;
    wrap.append(before, after);

    el.textContent = text.slice(0, -oldWord.length);
    el.append(wrap);
}
